export function logError(error: any) {
  console.error(error);
  alert(error);
}
